import { FIELDS_TO_TRANSFORM } from "services/sosInventoryService/lot/schema";
import { normalizeDateFields } from "services/utility/beforeSave";
import { convertNativeToCustom } from "services/utility/customFields";

export function beforeSave(record) {
  const newRecord = { ...record };

  newRecord.customFields = convertNativeToCustom(record.customFields);

  return normalizeDateFields(newRecord, FIELDS_TO_TRANSFORM.DATE_FIELDS);
}
